module.exports = __webpack_public_path__ + "assets/img/288.png?cb8df73de2b0d87ac8d7ccc02b558467";